import { createContext } from 'react';

import { PaginatedResult } from '../../table/paginated-result';

export interface FetchRecordContextType<RecordType> {
    record: RecordType;
    loading: boolean;
    error: unknown;
    params?: Record<string, any>;
    setParams?: (p: Record<string, any>) => void;
    fetchRecord: (params?: Record<string, any>) => Promise<void>;
    meta?: PaginatedResult<RecordType>['meta'];
}

export default createContext<FetchRecordContextType<any>>(undefined as any);
